import type { TextFieldProps } from "@mui/material";
import type { ReactElement } from "react";
import { MergeTagAutocomplete } from "../../../merge-tag/components/merge-tag-auto-complete";
import type { TagGroup } from "../../../merge-tag/components/types";

interface Props {
  defaultValue: string;
  filterTags: (x: string) => TagGroup;
  onChange: (value: string) => void;
  openingTag?: string;
  closingTag?: string;
  renderInput: (params: TextFieldProps) => ReactElement;
}

export const AutoCompleteSelector = ({ ...rest }: Props): ReactElement => (
  <MergeTagAutocomplete {...rest} />
);
